module.exports = __webpack_public_path__ + "21d44e966b0f57bf63c47600fe95e06e.svg";